import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { Box, Button, Chip } from "@mui/material";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { LEAVE_GRANT_TABLE_HEAD } from "../../../../components/datagrid/leave/LeaveGrantTableHead";
import { getLeaveGrantRequests } from "../../../../redux/features/leaveSlice";
import ApproveLeaveGrant from "./ApproveLeaveGrant";
import DeleteLeaveGrantRequest from "./DeleteGrantReq";
import EditLGR from "./EditLeaveGrantRequest";

const LeaveGrantApplications = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading, requests } = useSelector((state) => state.leave);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const [action, setActionOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();

  const profile = JSON.parse(localStorage.getItem('cred')).profile;

  const columns = useMemo(
    () => [
      ...LEAVE_GRANT_TABLE_HEAD,
      {
        field: "hod_status",
        minWidth: 200,
        headerName: "HOD Status",
        renderCell: (params) => {
          if (params.row.hod_status === 1) {
            return (
              <Chip
                label="Grant Approved"
                color="success"
                size="medium"
                variant="outlined"
              />
            );
          } else if (params.row.hod_status === 2) {
            return (
              <Chip
                label="Request Rejected"
                color="error"
                size="medium"
                variant="outlined"
              />
            );
          } else {
            return (
              <Chip
                label="Request Pending"
                color="warning"
                size="medium"
                variant="outlined"
              />
            );
          }
        },
      },
      {
        field: "hr_status",
        minWidth: 200,
        headerName: "HR Status",
        renderCell: (params) => {
          if (params.row.hr_status === 1) {
            return (
              <Chip
                label="Grant Approved"
                color="success"
                size="medium"
                variant="outlined"
              />
            );
          } else if (params.row.hr_status === 2) {
            return (
              <Chip
                label="Request Rejected"
                color="error"
                size="medium"
                variant="outlined"
              />
            );
          } else {
            return (
              <Chip
                label="Request Pending"
                color="warning"
                size="medium"
                variant="outlined"
              />
            );
          }
        },
      },
      {
        field: "Edit",
        minWidth: 200,
        headerName: "Edit",
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="outlined"
              color="primary"
              disabled={
                params.row.hr_status === 1 || params.row.hod_status === 1 || params.row.created_user !== profile?.userId
              }
              startIcon={<Icon icon={"mdi:pencil"} width={18} height={18} />}
              onClick={() => {
                setSelectedRow(params.row);
                setActionOpen(true);
              }}
            >
              Edit Request
            </Button>
          );
        },
      },
      {
        field: "Delete",
        minWidth: 150,
        headerName: "Delete",
        renderCell: (params) => {
          return (
            <DeleteLeaveGrantRequest
              leaveID={params.row.leave_id}
              dispatchdata={data}
              disabled={
                params.row.hod_status === 1 || params.row.hr_status === 1 || params.row.created_user !== profile?.userId
              }
            />
          );
        },
      },
    ],
    [LEAVE_GRANT_TABLE_HEAD]
  );

  const data = {
    page: pageNum,
    limit: gridSize,
    search: search || "",
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getLeaveGrantRequests(data));
    }
  }, [pageNum, gridSize, search]);

  return (
    <GlobalWrapper title={"WFH Grant Requests"} actions={
      <Button
        variant="contained"
        color="primary"
        size="medium"
        startIcon={<Icon icon={"fluent:note-edit-20-regular"} width={18} height={18} />}
        onClick={() => navigate("/employeeservices/grant-request")}
      >
        Apply for Grant
      </Button>
    }>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={columns}
          rows={requests?.data}
          meta={requests?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="leave_id"
          rowClick={false}
        />
        {action && selectedRow && (
          <EditLGR
            open={action}
            setOpen={setActionOpen}
            row={selectedRow}
            dispatchData={data}
          />
        )}
      </Box>
    </GlobalWrapper>
  );
};

export default LeaveGrantApplications;
